import {KpiType} from '@hconnect/common/types'

export const PERFORMANCE_REVIEW_KPI_TYPES = [
  KpiType.ClinkerProduction,
  KpiType.CementProduction,
  KpiType.AlternativeFuelRate,
  KpiType.KilnHeatConsumption,
  KpiType.TechnicalCementPowerConsumption,
  KpiType.ClinkerIncorporation,
  KpiType.CO2EmissionsPerCement,
  KpiType.MaintenanceCosts,
  KpiType.KilnReliabilityCoefficient,
  KpiType.KilnOperatingCoefficient,
  KpiType.KilnMTBF,
  KpiType.FinishMillOperatingCoefficient
] as const
